import { DeviceTier } from '@/views/event/FloatingEmoji/types';

export const MAX_FLOATERS_PER_EMOJI = 3;
export const BURST_PERCENT = 0.02;
export const BURST_MIN_ABSOLUTE = 5;
export const LANE_JITTER = 0.3;
export const LANE_COOLDOWN_MS = 600;
export const LANE_DRIFT_FRACTION = 0.35;
export const EMOJI_CACHE_SIZE = 128;

export const DEVICE_CONFIG: Record<
  DeviceTier,
  { maxParticles: number; sizeMin: number; sizeMax: number; laneCount: number }
> = {
  mobile: { maxParticles: 80, sizeMin: 26, sizeMax: 36, laneCount: 3 },
  tablet: { maxParticles: 150, sizeMin: 32, sizeMax: 42, laneCount: 4 },
  desktop: { maxParticles: 350, sizeMin: 48, sizeMax: 60, laneCount: 6 }
};

export const FLOAT_ANIMATION = { lifetimeMin: 2.8, lifetimeMax: 3.4 };

export const MAX_VISIBLE_FLOATS = 36;
export const EVICTION_THRESHOLD = 0.5;
export const STAGGER_BASE_MS = 200;
export const STAGGER_JITTER_MS = 100;

// Cannon Constants

export const CANNON_DEVICE_CONFIG: Record<DeviceTier, { riseBase: number; fragBase: number }> = {
  mobile: { riseBase: 36, fragBase: 40 },
  tablet: { riseBase: 44, fragBase: 48 },
  desktop: { riseBase: 50, fragBase: 55 }
};

export const PHASE = {
  riseDuration: 1.3,
  holdDuration: 0.35,
  burstDuration: 1.6
} as const;

export const RISE = {
  startY: 1.12,
  startScale: 0.15,
  peakScale: 1.3,
  xMin: 0.06,
  xMax: 0.18,
  wobbleAmplitude: 0.012,
  wobbleFrequency: 1.5
} as const;

export const BURST = {
  minFragments: 10,
  maxFragments: 22,
  spreadRadius: 0.14,
  driftWidth: 0.02,
  driftFrequency: 0.5
} as const;
